module.exports = __webpack_public_path__ + "static/media/wypelnienie-on.44263ca8.svg";